import { Bar, BarChart, XAxis, YAxis, LabelList, Cell } from "recharts"
import { Card, CardContent } from "./Card"
import { ChartContainer } from "./Chart"

const COLORS = ["#10b981", "#3b82f6", "#f59e0b", "#ef4444"];

export default function DeliveryTimeChart({ type, data }) {
  const chartData = (data || []).map((item) => ({
    name: item.name,
    value: item.value,
  }));

  const chartConfig = {
    value: {
      label: "%",
      color: "#3b82f6",
    },
    label: {
      color: "#fff",
    },
  };

  return (
    <Card className="shadow-none border-none m-0 p-0">
      <CardContent className="p-0 m-0">
        <ChartContainer config={chartConfig} className={`h-44 ${type === true ? "w-full" : "w-full"}`}>
          <BarChart
            accessibilityLayer
            data={chartData}
            layout="vertical"
            margin={{ top: 16, right: 0, left: 0, bottom: 0 }}
          >
            <XAxis type="number" fontSize={9} domain={[0, 100]} tickFormatter={(v) => `${v}%`} fontSize={10} tickLine={false} axisLine={false} />
            <YAxis
              type="category"
              dataKey="name"
              tickLine={false}
              axisLine={false}
              fontSize={10}
              width={66}
              className="bg-red-500"
            />
            <Bar dataKey="value" radius={4} barSize={20}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
              <LabelList
                dataKey="value"
                position="right"
                className="fill-foreground font-medium"
                fontSize={11}
                formatter={(val) => (val === 0 ? "" : `${val}%`)}
              />
            </Bar>
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
